/**
 * Comprehensive World Countries & Phone Codes Dataset
 * Covers all UN recognized sovereign states, dependent territories,
 * Arab league members, and an explicit Custom/Other option.
 */

export const ALL_COUNTRIES = [
  // Special Custom Option
  { code: 'CUSTOM', dial: '', flag: '🌐', nameAr: 'رمز مخصص / دولة أخرى', nameEn: 'Custom Code / Other' },

  // Arab League Nations (22 States)
  { code: 'EG', dial: '20', flag: '🇪🇬', nameAr: 'مصر', nameEn: 'Egypt' },
  { code: 'SA', dial: '966', flag: '🇸🇦', nameAr: 'المملكة العربية السعودية', nameEn: 'Saudi Arabia' },
  { code: 'AE', dial: '971', flag: '🇦🇪', nameAr: 'الإمارات العربية المتحدة', nameEn: 'United Arab Emirates' },
  { code: 'KW', dial: '965', flag: '🇰🇼', nameAr: 'الكويت', nameEn: 'Kuwait' },
  { code: 'QA', dial: '974', flag: '🇶🇦', nameAr: 'قطر', nameEn: 'Qatar' },
  { code: 'OM', dial: '968', flag: '🇴🇲', nameAr: 'عُمان', nameEn: 'Oman' },
  { code: 'BH', dial: '973', flag: '🇧🇭', nameAr: 'البحرين', nameEn: 'Bahrain' },
  { code: 'JO', dial: '962', flag: '🇯🇴', nameAr: 'الأردن', nameEn: 'Jordan' },
  { code: 'PS', dial: '970', flag: '🇵🇸', nameAr: 'فلسطين', nameEn: 'Palestine' },
  { code: 'IQ', dial: '964', flag: '🇮🇶', nameAr: 'العراق', nameEn: 'Iraq' },
  { code: 'LB', dial: '961', flag: '🇱🇧', nameAr: 'لبنان', nameEn: 'Lebanon' },
  { code: 'SY', dial: '963', flag: '🇸🇾', nameAr: 'سوريا', nameEn: 'Syria' },
  { code: 'YE', dial: '967', flag: '🇾🇪', nameAr: 'اليمن', nameEn: 'Yemen' },
  { code: 'MA', dial: '212', flag: '🇲🇦', nameAr: 'المغرب', nameEn: 'Morocco' },
  { code: 'DZ', dial: '213', flag: '🇩🇿', nameAr: 'الجزائر', nameEn: 'Algeria' },
  { code: 'TN', dial: '216', flag: '🇹🇳', nameAr: 'تونس', nameEn: 'Tunisia' },
  { code: 'LY', dial: '218', flag: '🇱🇾', nameAr: 'ليبيا', nameEn: 'Libya' },
  { code: 'SD', dial: '249', flag: '🇸🇩', nameAr: 'السودان', nameEn: 'Sudan' },
  { code: 'SO', dial: '252', flag: '🇸🇴', nameAr: 'الصومال', nameEn: 'Somalia' },
  { code: 'MR', dial: '222', flag: '🇲🇷', nameAr: 'موريتانيا', nameEn: 'Mauritania' },
  { code: 'DJ', dial: '253', flag: '🇩🇯', nameAr: 'جيبوتي', nameEn: 'Djibouti' },
  { code: 'KM', dial: '269', flag: '🇰🇲', nameAr: 'جزر القمر', nameEn: 'Comoros' },

  // Europe & Transcontinental
  { code: 'TR', dial: '90', flag: '🇹🇷', nameAr: 'تركيا', nameEn: 'Turkey' },
  { code: 'GB', dial: '44', flag: '🇬🇧', nameAr: 'المملكة المتحدة', nameEn: 'United Kingdom' },
  { code: 'DE', dial: '49', flag: '🇩🇪', nameAr: 'ألمانيا', nameEn: 'Germany' },
  { code: 'FR', dial: '33', flag: '🇫🇷', nameAr: 'فرنسا', nameEn: 'France' },
  { code: 'IT', dial: '39', flag: '🇮🇹', nameAr: 'إيطاليا', nameEn: 'Italy' },
  { code: 'ES', dial: '34', flag: '🇪🇸', nameAr: 'إسبانيا', nameEn: 'Spain' },
  { code: 'NL', dial: '31', flag: '🇳🇱', nameAr: 'هولندا', nameEn: 'Netherlands' },
  { code: 'BE', dial: '32', flag: '🇧🇪', nameAr: 'بلجيكا', nameEn: 'Belgium' },
  { code: 'CH', dial: '41', flag: '🇨🇭', nameAr: 'سويسرا', nameEn: 'Switzerland' },
  { code: 'SE', dial: '46', flag: '🇸🇪', nameAr: 'السويد', nameEn: 'Sweden' },
  { code: 'NO', dial: '47', flag: '🇳🇴', nameAr: 'النرويج', nameEn: 'Norway' },
  { code: 'DK', dial: '45', flag: '🇩🇰', nameAr: 'الدنمارك', nameEn: 'Denmark' },
  { code: 'FI', dial: '358', flag: '🇫🇮', nameAr: 'فنلندا', nameEn: 'Finland' },
  { code: 'AT', dial: '43', flag: '🇦🇹', nameAr: 'النمسا', nameEn: 'Austria' },
  { code: 'GR', dial: '30', flag: '🇬🇷', nameAr: 'اليونان', nameEn: 'Greece' },
  { code: 'PT', dial: '351', flag: '🇵🇹', nameAr: 'البرتغال', nameEn: 'Portugal' },
  { code: 'IE', dial: '353', flag: '🇮🇪', nameAr: 'أيرلندا', nameEn: 'Ireland' },
  { code: 'PL', dial: '48', flag: '🇵🇱', nameAr: 'بولندا', nameEn: 'Poland' },
  { code: 'RU', dial: '7', flag: '🇷🇺', nameAr: 'روسيا', nameEn: 'Russia' },
  { code: 'UA', dial: '380', flag: '🇺🇦', nameAr: 'أوكرانيا', nameEn: 'Ukraine' },
  { code: 'CZ', dial: '420', flag: '🇨🇿', nameAr: 'التشيك', nameEn: 'Czech Republic' },
  { code: 'RO', dial: '40', flag: '🇷🇴', nameAr: 'رومانيا', nameEn: 'Romania' },
  { code: 'HU', dial: '36', flag: '🇭🇺', nameAr: 'المجر', nameEn: 'Hungary' },
  { code: 'BY', dial: '375', flag: '🇧🇾', nameAr: 'بيلاروسيا', nameEn: 'Belarus' },
  { code: 'BG', dial: '359', flag: '🇧🇬', nameAr: 'بلغاريا', nameEn: 'Bulgaria' },
  { code: 'RS', dial: '381', flag: '🇷🇸', nameAr: 'صربيا', nameEn: 'Serbia' },
  { code: 'HR', dial: '385', flag: '🇭🇷', nameAr: 'كرواتيا', nameEn: 'Croatia' },
  { code: 'SK', dial: '421', flag: '🇸🇰', nameAr: 'سلوفاكيا', nameEn: 'Slovakia' },
  { code: 'SI', dial: '386', flag: '🇸🇮', nameAr: 'سلوفينيا', nameEn: 'Slovenia' },
  { code: 'BA', dial: '387', flag: '🇧🇦', nameAr: 'البوسنة والهرسك', nameEn: 'Bosnia and Herzegovina' },
  { code: 'AL', dial: '355', flag: '🇦🇱', nameAr: 'ألبانيا', nameEn: 'Albania' },
  { code: 'MK', dial: '389', flag: '🇲🇰', nameAr: 'مقدونيا الشمالية', nameEn: 'North Macedonia' },
  { code: 'ME', dial: '382', flag: '🇲🇪', nameAr: 'الجبل الأسود', nameEn: 'Montenegro' },
  { code: 'CY', dial: '357', flag: '🇨🇾', nameAr: 'قبرص', nameEn: 'Cyprus' },
  { code: 'MT', dial: '356', flag: '🇲🇹', nameAr: 'مالطا', nameEn: 'Malta' },
  { code: 'IS', dial: '354', flag: '🇮🇸', nameAr: 'آيسلندا', nameEn: 'Iceland' },
  { code: 'LU', dial: '352', flag: '🇱🇺', nameAr: 'لوكسمبورغ', nameEn: 'Luxembourg' },
  { code: 'EE', dial: '372', flag: '🇪🇪', nameAr: 'إستونيا', nameEn: 'Estonia' },
  { code: 'LV', dial: '371', flag: '🇱🇻', nameAr: 'لاتفيا', nameEn: 'Latvia' },
  { code: 'LT', dial: '370', flag: '🇱🇹', nameAr: 'ليتوانيا', nameEn: 'Lithuania' },
  { code: 'MD', dial: '373', flag: '🇲🇩', nameAr: 'مولدوفا', nameEn: 'Moldova' },
  { code: 'GE', dial: '995', flag: '🇬🇪', nameAr: 'جورجيا', nameEn: 'Georgia' },
  { code: 'AM', dial: '374', flag: '🇦🇲', nameAr: 'أرمينيا', nameEn: 'Armenia' },
  { code: 'AZ', dial: '994', flag: '🇦🇿', nameAr: 'أذربيجان', nameEn: 'Azerbaijan' },
  { code: 'MC', dial: '377', flag: '🇲🇨', nameAr: 'موناكو', nameEn: 'Monaco' },
  { code: 'AD', dial: '376', flag: '🇦🇩', nameAr: 'أندورا', nameEn: 'Andorra' },
  { code: 'LI', dial: '423', flag: '🇱🇮', nameAr: 'ليختنشتاين', nameEn: 'Liechtenstein' },
  { code: 'SM', dial: '378', flag: '🇸🇲', nameAr: 'سان مارينو', nameEn: 'San Marino' },
  { code: 'VA', dial: '379', flag: '🇻🇦', nameAr: 'الفاتيكان', nameEn: 'Vatican City' },
  { code: 'XK', dial: '383', flag: '🇽🇰', nameAr: 'كوسوفو', nameEn: 'Kosovo' },
  { code: 'GI', dial: '350', flag: '🇬🇮', nameAr: 'جبل طارق', nameEn: 'Gibraltar' },

  // Asia & Pacific
  { code: 'CN', dial: '86', flag: '🇨🇳', nameAr: 'الصين', nameEn: 'China' },
  { code: 'IN', dial: '91', flag: '🇮🇳', nameAr: 'الهند', nameEn: 'India' },
  { code: 'PK', dial: '92', flag: '🇵🇰', nameAr: 'باكستان', nameEn: 'Pakistan' },
  { code: 'BD', dial: '880', flag: '🇧🇩', nameAr: 'بنغلاديش', nameEn: 'Bangladesh' },
  { code: 'ID', dial: '62', flag: '🇮🇩', nameAr: 'إندونيسيا', nameEn: 'Indonesia' },
  { code: 'MY', dial: '60', flag: '🇲🇾', nameAr: 'ماليزيا', nameEn: 'Malaysia' },
  { code: 'PH', dial: '63', flag: '🇵🇭', nameAr: 'الفلبين', nameEn: 'Philippines' },
  { code: 'VN', dial: '84', flag: '🇻🇳', nameAr: 'فيتنام', nameEn: 'Vietnam' },
  { code: 'TH', dial: '66', flag: '🇹🇭', nameAr: 'تايلاند', nameEn: 'Thailand' },
  { code: 'SG', dial: '65', flag: '🇸🇬', nameAr: 'سنغافورة', nameEn: 'Singapore' },
  { code: 'JP', dial: '81', flag: '🇯🇵', nameAr: 'اليابان', nameEn: 'Japan' },
  { code: 'KR', dial: '82', flag: '🇰🇷', nameAr: 'كوريا الجنوبية', nameEn: 'South Korea' },
  { code: 'KP', dial: '850', flag: '🇰🇵', nameAr: 'كوريا الشمالية', nameEn: 'North Korea' },
  { code: 'TW', dial: '886', flag: '🇹🇼', nameAr: 'تايوان', nameEn: 'Taiwan' },
  { code: 'HK', dial: '852', flag: '🇭🇰', nameAr: 'هونغ كونغ', nameEn: 'Hong Kong' },
  { code: 'MO', dial: '853', flag: '🇲🇴', nameAr: 'ماكاو', nameEn: 'Macao' },
  { code: 'IR', dial: '98', flag: '🇮🇷', nameAr: 'إيران', nameEn: 'Iran' },
  { code: 'AF', dial: '93', flag: '🇦🇫', nameAr: 'أفغانستان', nameEn: 'Afghanistan' },
  { code: 'LK', dial: '94', flag: '🇱🇰', nameAr: 'سريلانكا', nameEn: 'Sri Lanka' },
  { code: 'MM', dial: '95', flag: '🇲🇲', nameAr: 'ميانمار (بورما)', nameEn: 'Myanmar' },
  { code: 'KH', dial: '855', flag: '🇰🇭', nameAr: 'كمبوديا', nameEn: 'Cambodia' },
  { code: 'LA', dial: '856', flag: '🇱🇦', nameAr: 'لاوس', nameEn: 'Laos' },
  { code: 'NP', dial: '977', flag: '🇳🇵', nameAr: 'نيبال', nameEn: 'Nepal' },
  { code: 'UZ', dial: '998', flag: '🇺🇿', nameAr: 'أوزبكستان', nameEn: 'Uzbekistan' },
  { code: 'KZ', dial: '7', flag: '🇰🇿', nameAr: 'كازاخستان', nameEn: 'Kazakhstan' },
  { code: 'TM', dial: '993', flag: '🇹🇲', nameAr: 'تركمانستان', nameEn: 'Turkmenistan' },
  { code: 'TJ', dial: '992', flag: '🇹🇯', nameAr: 'طاجيكستان', nameEn: 'Tajikistan' },
  { code: 'KG', dial: '996', flag: '🇰🇬', nameAr: 'قيرغيزستان', nameEn: 'Kyrgyzstan' },
  { code: 'MN', dial: '976', flag: '🇲🇳', nameAr: 'منغوليا', nameEn: 'Mongolia' },
  { code: 'MV', dial: '960', flag: '🇲🇻', nameAr: 'المالديف', nameEn: 'Maldives' },
  { code: 'BN', dial: '673', flag: '🇧🇳', nameAr: 'بروناي', nameEn: 'Brunei' },
  { code: 'BT', dial: '975', flag: '🇧🇹', nameAr: 'بوتان', nameEn: 'Bhutan' },
  { code: 'TL', dial: '670', flag: '🇹🇱', nameAr: 'تيمور الشرقية', nameEn: 'Timor-Leste' },

  // Americas (North, Central, South & Caribbean)
  { code: 'US', dial: '1', flag: '🇺🇸', nameAr: 'الولايات المتحدة', nameEn: 'United States' },
  { code: 'CA', dial: '1', flag: '🇨🇦', nameAr: 'كندا', nameEn: 'Canada' },
  { code: 'MX', dial: '52', flag: '🇲🇽', nameAr: 'المكسيك', nameEn: 'Mexico' },
  { code: 'BR', dial: '55', flag: '🇧🇷', nameAr: 'البرازيل', nameEn: 'Brazil' },
  { code: 'AR', dial: '54', flag: '🇦🇷', nameAr: 'الأرجنتين', nameEn: 'Argentina' },
  { code: 'CO', dial: '57', flag: '🇨🇴', nameAr: 'كولومبيا', nameEn: 'Colombia' },
  { code: 'CL', dial: '56', flag: '🇨🇱', nameAr: 'تشيلي', nameEn: 'Chile' },
  { code: 'PE', dial: '51', flag: '🇵🇪', nameAr: 'بيرو', nameEn: 'Peru' },
  { code: 'VE', dial: '58', flag: '🇻🇪', nameAr: 'فنزويلا', nameEn: 'Venezuela' },
  { code: 'EC', dial: '593', flag: '🇪🇨', nameAr: 'الإكوادور', nameEn: 'Ecuador' },
  { code: 'GT', dial: '502', flag: '🇬🇹', nameAr: 'غواتيمالا', nameEn: 'Guatemala' },
  { code: 'CU', dial: '53', flag: '🇨🇺', nameAr: 'كوبا', nameEn: 'Cuba' },
  { code: 'BO', dial: '591', flag: '🇧🇴', nameAr: 'بوليفيا', nameEn: 'Bolivia' },
  { code: 'DO', dial: '1809', flag: '🇩🇴', nameAr: 'جمهورية الدومينيكان', nameEn: 'Dominican Republic' },
  { code: 'HN', dial: '504', flag: '🇭🇳', nameAr: 'هندوراس', nameEn: 'Honduras' },
  { code: 'PY', dial: '595', flag: '🇵🇾', nameAr: 'باراغواي', nameEn: 'Paraguay' },
  { code: 'NI', dial: '505', flag: '🇳🇮', nameAr: 'نيكاراغوا', nameEn: 'Nicaragua' },
  { code: 'SV', dial: '503', flag: '🇸🇻', nameAr: 'السلفادور', nameEn: 'El Salvador' },
  { code: 'CR', dial: '506', flag: '🇨🇷', nameAr: 'كوستاريكا', nameEn: 'Costa Rica' },
  { code: 'PA', dial: '507', flag: '🇵🇦', nameAr: 'بنما', nameEn: 'Panama' },
  { code: 'UY', dial: '598', flag: '🇺🇾', nameAr: 'أوروغواي', nameEn: 'Uruguay' },
  { code: 'JM', dial: '1876', flag: '🇯🇲', nameAr: 'جامايكا', nameEn: 'Jamaica' },
  { code: 'PR', dial: '1787', flag: '🇵🇷', nameAr: 'بورتوريكو', nameEn: 'Puerto Rico' },
  { code: 'TT', dial: '1868', flag: '🇹🇹', nameAr: 'ترينيداد وتوباغو', nameEn: 'Trinidad and Tobago' },
  { code: 'GY', dial: '592', flag: '🇬🇾', nameAr: 'غيانا', nameEn: 'Guyana' },
  { code: 'SR', dial: '597', flag: '🇸🇷', nameAr: 'سورينام', nameEn: 'Suriname' },
  { code: 'BZ', dial: '501', flag: '🇧🇿', nameAr: 'بليز', nameEn: 'Belize' },
  { code: 'BS', dial: '1242', flag: '🇧🇸', nameAr: 'جزر البهاما', nameEn: 'Bahamas' },
  { code: 'BB', dial: '1246', flag: '🇧🇧', nameAr: 'باربادوس', nameEn: 'Barbados' },
  { code: 'HT', dial: '509', flag: '🇭🇹', nameAr: 'هايتي', nameEn: 'Haiti' },
  { code: 'LC', dial: '1758', flag: '🇱🇨', nameAr: 'سانت لوسيا', nameEn: 'Saint Lucia' },
  { code: 'GD', dial: '1473', flag: '🇬🇩', nameAr: 'غرينادا', nameEn: 'Grenada' },
  { code: 'VC', dial: '1784', flag: '🇻🇨', nameAr: 'سانت فنسنت والغرينادين', nameEn: 'Saint Vincent and the Grenadines' },
  { code: 'AG', dial: '1268', flag: '🇦🇬', nameAr: 'أنتيغوا وبربودا', nameEn: 'Antigua and Barbuda' },
  { code: 'DM', dial: '1767', flag: '🇩🇲', nameAr: 'دومينيكا', nameEn: 'Dominica' },
  { code: 'KN', dial: '1869', flag: '🇰🇳', nameAr: 'سانت كيتس ونيفيس', nameEn: 'Saint Kitts and Nevis' },
  { code: 'KY', dial: '1345', flag: '🇰🇾', nameAr: 'جزر كايمان', nameEn: 'Cayman Islands' },
  { code: 'BM', dial: '1441', flag: '🇧🇲', nameAr: 'برمودا', nameEn: 'Bermuda' },
  { code: 'AW', dial: '297', flag: '🇦🇼', nameAr: 'أروبا', nameEn: 'Aruba' },
  { code: 'CW', dial: '599', flag: '🇨🇼', nameAr: 'كوراساو', nameEn: 'Curacao' },

  // Africa
  { code: 'NG', dial: '234', flag: '🇳🇬', nameAr: 'نيجيريا', nameEn: 'Nigeria' },
  { code: 'ZA', dial: '27', flag: '🇿🇦', nameAr: 'جنوب إفريقيا', nameEn: 'South Africa' },
  { code: 'KE', dial: '254', flag: '🇰🇪', nameAr: 'كينيا', nameEn: 'Kenya' },
  { code: 'ET', dial: '251', flag: '🇪🇹', nameAr: 'إثيوبيا', nameEn: 'Ethiopia' },
  { code: 'GH', dial: '233', flag: '🇬🇭', nameAr: 'غانا', nameEn: 'Ghana' },
  { code: 'TZ', dial: '255', flag: '🇹🇿', nameAr: 'تنزانيا', nameEn: 'Tanzania' },
  { code: 'UG', dial: '256', flag: '🇺🇬', nameAr: 'أوغندا', nameEn: 'Uganda' },
  { code: 'AO', dial: '244', flag: '🇦🇴', nameAr: 'أنغولا', nameEn: 'Angola' },
  { code: 'MZ', dial: '258', flag: '🇲🇿', nameAr: 'موزمبيق', nameEn: 'Mozambique' },
  { code: 'MG', dial: '261', flag: '🇲🇬', nameAr: 'مدغشقر', nameEn: 'Madagascar' },
  { code: 'CI', dial: '225', flag: '🇨🇮', nameAr: 'ساحل العاج', nameEn: 'Ivory Coast' },
  { code: 'CM', dial: '237', flag: '🇨🇲', nameAr: 'الكاميرون', nameEn: 'Cameroon' },
  { code: 'NE', dial: '227', flag: '🇳🇪', nameAr: 'النيجر', nameEn: 'Niger' },
  { code: 'ML', dial: '223', flag: '🇲🇱', nameAr: 'مالي', nameEn: 'Mali' },
  { code: 'BF', dial: '226', flag: '🇧🇫', nameAr: 'بوركينا فاسو', nameEn: 'Burkina Faso' },
  { code: 'MW', dial: '265', flag: '🇲🇼', nameAr: 'مالاوي', nameEn: 'Malawi' },
  { code: 'ZM', dial: '260', flag: '🇿🇲', nameAr: 'زامبيا', nameEn: 'Zambia' },
  { code: 'TD', dial: '235', flag: '🇹🇩', nameAr: 'تشاد', nameEn: 'Chad' },
  { code: 'SN', dial: '221', flag: '🇸🇳', nameAr: 'السنغال', nameEn: 'Senegal' },
  { code: 'ZW', dial: '263', flag: '🇿🇼', nameAr: 'زيمبابوي', nameEn: 'Zimbabwe' },
  { code: 'GN', dial: '224', flag: '🇬🇳', nameAr: 'غينيا', nameEn: 'Guinea' },
  { code: 'RW', dial: '250', flag: '🇷🇼', nameAr: 'رواندا', nameEn: 'Rwanda' },
  { code: 'BJ', dial: '229', flag: '🇧🇯', nameAr: 'بنين', nameEn: 'Benin' },
  { code: 'BI', dial: '257', flag: '🇧🇮', nameAr: 'بوروندي', nameEn: 'Burundi' },
  { code: 'SS', dial: '211', flag: '🇸🇸', nameAr: 'جنوب السودان', nameEn: 'South Sudan' },
  { code: 'TG', dial: '228', flag: '🇹🇬', nameAr: 'توغو', nameEn: 'Togo' },
  { code: 'SL', dial: '232', flag: '🇸🇱', nameAr: 'سيراليون', nameEn: 'Sierra Leone' },
  { code: 'CG', dial: '242', flag: '🇨🇬', nameAr: 'الكونغو', nameEn: 'Congo' },
  { code: 'CD', dial: '243', flag: '🇨🇩', nameAr: 'جمهورية الكونغو الديمقراطية', nameEn: 'DR Congo' },
  { code: 'LR', dial: '231', flag: '🇱🇷', nameAr: 'ليبيريا', nameEn: 'Liberia' },
  { code: 'CF', dial: '236', flag: '🇨🇫', nameAr: 'جمهورية إفريقيا الوسطى', nameEn: 'Central African Republic' },
  { code: 'NA', dial: '264', flag: '🇳🇦', nameAr: 'ناميبيا', nameEn: 'Namibia' },
  { code: 'BW', dial: '267', flag: '🇧🇼', nameAr: 'بوتسوانا', nameEn: 'Botswana' },
  { code: 'GA', dial: '241', flag: '🇬🇦', nameAr: 'الغابون', nameEn: 'Gabon' },
  { code: 'LS', dial: '266', flag: '🇱🇸', nameAr: 'ليسوتو', nameEn: 'Lesotho' },
  { code: 'GW', dial: '245', flag: '🇬🇼', nameAr: 'غينيا بيساو', nameEn: 'Guinea-Bissau' },
  { code: 'GQ', dial: '240', flag: '🇬🇶', nameAr: 'غينيا الاستوائية', nameEn: 'Equatorial Guinea' },
  { code: 'MU', dial: '230', flag: '🇲🇺', nameAr: 'موريشيوس', nameEn: 'Mauritius' },
  { code: 'SZ', dial: '268', flag: '🇸🇿', nameAr: 'إسواتيني', nameEn: 'Eswatini' },
  { code: 'CV', dial: '238', flag: '🇨🇻', nameAr: 'الرأس الأخضر', nameEn: 'Cape Verde' },
  { code: 'SC', dial: '248', flag: '🇸🇨', nameAr: 'سيشل', nameEn: 'Seychelles' },
  { code: 'ST', dial: '239', flag: '🇸🇹', nameAr: 'ساو تومي وبرينسيب', nameEn: 'Sao Tome and Principe' },
  { code: 'ER', dial: '291', flag: '🇪🇷', nameAr: 'إريتريا', nameEn: 'Eritrea' },
  { code: 'GM', dial: '220', flag: '🇬🇲', nameAr: 'غامبيا', nameEn: 'Gambia' },

  // Oceania
  { code: 'AU', dial: '61', flag: '🇦🇺', nameAr: 'أستراليا', nameEn: 'Australia' },
  { code: 'NZ', dial: '64', flag: '🇳🇿', nameAr: 'نيوزيلندا', nameEn: 'New Zealand' },
  { code: 'PG', dial: '675', flag: '🇵🇬', nameAr: 'بابوا غينيا الجديدة', nameEn: 'Papua New Guinea' },
  { code: 'FJ', dial: '679', flag: '🇫🇯', nameAr: 'فيجي', nameEn: 'Fiji' },
  { code: 'SB', dial: '677', flag: '🇸🇧', nameAr: 'جزر سليمان', nameEn: 'Solomon Islands' },
  { code: 'VU', dial: '678', flag: '🇻🇺', nameAr: 'فانواتو', nameEn: 'Vanuatu' },
  { code: 'WS', dial: '685', flag: '🇼🇸', nameAr: 'ساموا', nameEn: 'Samoa' },
  { code: 'KI', dial: '686', flag: '🇰🇮', nameAr: 'كيريباتي', nameEn: 'Kiribati' },
  { code: 'TO', dial: '676', flag: '🇹🇴', nameAr: 'تونغا', nameEn: 'Tonga' },
  { code: 'FM', dial: '691', flag: '🇫🇲', nameAr: 'ميكرونيزيا', nameEn: 'Micronesia' },
  { code: 'PW', dial: '680', flag: '🇵🇼', nameAr: 'بالاو', nameEn: 'Palau' },
  { code: 'MH', dial: '692', flag: '🇲🇭', nameAr: 'جزر مارشال', nameEn: 'Marshall Islands' },
  { code: 'TV', dial: '688', flag: '🇹🇻', nameAr: 'توفالو', nameEn: 'Tuvalu' },
  { code: 'NR', dial: '674', flag: '🇳🇷', nameAr: 'ناورو', nameEn: 'Nauru' }
];

// Timezone to Country Code Mapping
export const TIMEZONE_TO_COUNTRY = {
  'Africa/Cairo': 'EG',
  'Asia/Riyadh': 'SA',
  'Asia/Dubai': 'AE',
  'Asia/Muscat': 'OM',
  'Asia/Kuwait': 'KW',
  'Asia/Qatar': 'QA',
  'Asia/Bahrain': 'BH',
  'Asia/Amman': 'JO',
  'Asia/Beirut': 'LB',
  'Asia/Baghdad': 'IQ',
  'Asia/Damascus': 'SY',
  'Asia/Gaza': 'PS',
  'Asia/Hebron': 'PS',
  'Asia/Jerusalem': 'PS',
  'Asia/Aden': 'YE',
  'Africa/Casablanca': 'MA',
  'Africa/Algiers': 'DZ',
  'Africa/Tunis': 'TN',
  'Africa/Tripoli': 'LY',
  'Africa/Khartoum': 'SD',
  'Africa/Nouakchott': 'MR',
  'Africa/Mogadishu': 'SO',
  'Africa/Djibouti': 'DJ',
  'Indian/Comoro': 'KM',
  'Europe/London': 'GB',
  'Europe/Berlin': 'DE',
  'Europe/Paris': 'FR',
  'Europe/Rome': 'IT',
  'Europe/Madrid': 'ES',
  'Europe/Amsterdam': 'NL',
  'Europe/Brussels': 'BE',
  'Europe/Vienna': 'AT',
  'Europe/Zurich': 'CH',
  'Europe/Stockholm': 'SE',
  'Europe/Oslo': 'NO',
  'Europe/Copenhagen': 'DK',
  'Europe/Athens': 'GR',
  'Europe/Dublin': 'IE',
  'Europe/Lisbon': 'PT',
  'Europe/Warsaw': 'PL',
  'Europe/Istanbul': 'TR',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'America/Phoenix': 'US',
  'America/Toronto': 'CA',
  'America/Vancouver': 'CA',
  'America/Montreal': 'CA',
  'Asia/Kolkata': 'IN',
  'Asia/Karachi': 'PK',
  'Asia/Dhaka': 'BD',
  'Asia/Jakarta': 'ID',
  'Asia/Kuala_Lumpur': 'MY',
  'Asia/Manila': 'PH',
  'Asia/Tokyo': 'JP',
  'Asia/Seoul': 'KR',
  'Asia/Shanghai': 'CN',
  'Australia/Sydney': 'AU',
  'Australia/Melbourne': 'AU',
  'Pacific/Auckland': 'NZ',
  'America/Sao_Paulo': 'BR',
  'America/Mexico_City': 'MX',
  'Africa/Johannesburg': 'ZA'
};

/**
 * Detect Visitor Country using Timezone or Locale hints
 */
export function detectUserCountry(isAr = true) {
  let detectedCode = null;

  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIMEZONE_TO_COUNTRY[tz]) {
      detectedCode = TIMEZONE_TO_COUNTRY[tz];
    }
  } catch {
    // fallback
  }

  if (!detectedCode) {
    const lang = (navigator.language || (navigator.languages && navigator.languages[0]) || '').toUpperCase();
    const parts = lang.split(/[-_]/);
    if (parts.length > 1 && ALL_COUNTRIES.some((c) => c.code === parts[1])) {
      detectedCode = parts[1];
    }
  }

  // Primary Fallback: Saudi Arabia (SA / +966 / SAR) as requested
  return detectedCode || 'SA';
}

/**
 * Global Country to Currency Mapping
 * Full coverage for all 22 Arab states and major global economies
 */
export const COUNTRY_TO_CURRENCY = {
  SA: 'SAR',
  EG: 'EGP',
  AE: 'AED',
  KW: 'KWD',
  QA: 'QAR',
  BH: 'BHD',
  OM: 'OMR',
  JO: 'JOD',
  IQ: 'IQD',
  MA: 'MAD',
  DZ: 'DZD',
  TN: 'TND',
  LY: 'LYD',
  SD: 'SDG',
  LB: 'LBP',
  SY: 'SYP',
  YE: 'YER',
  PS: 'JOD',
  MR: 'MRU',
  SO: 'SOS',
  DJ: 'DJF',
  KM: 'KMF',
  US: 'USD',
  GB: 'GBP',
  DE: 'EUR',
  FR: 'EUR',
  IT: 'EUR',
  ES: 'EUR',
  TR: 'TRY',
  CA: 'CAD',
  AU: 'AUD',
  JP: 'JPY',
  CN: 'CNY',
  IN: 'INR'
};

/**
 * Detect Visitor Currency automatically based on detected country
 * Fallback: 'SAR' (Saudi Riyal)
 */
export function detectUserCurrency(defaultCurrency = 'SAR') {
  const code = detectUserCountry();
  return (code && COUNTRY_TO_CURRENCY[code]) || defaultCurrency;
}

/**
 * Sanitize & Format Phone Number
 */
export function sanitizePhoneNumber(countryDial, rawPhone) {
  const cleanDial = String(countryDial || '').replace(/\D/g, '');
  let cleanPhone = String(rawPhone || '').replace(/\D/g, '');

  // Strip leading zero from local phone number
  cleanPhone = cleanPhone.replace(/^0+/, '');

  // Avoid duplicating dial code if user typed the whole international number
  if (cleanDial && cleanPhone.startsWith(cleanDial) && cleanPhone.length > cleanDial.length + 5) {
    return cleanPhone;
  }

  return `${cleanDial}${cleanPhone}`;
}

/**
 * Populate Country Select with Alphabetically Sorted Countries + Custom Option
 */
export function populateCountrySelect(selectEl, isAr, defaultCode = null, dialInputEl = null) {
  if (!selectEl) return;

  const collator = new Intl.Collator(isAr ? 'ar' : 'en', { sensitivity: 'base' });
  const regularCountries = ALL_COUNTRIES.filter((c) => c.code !== 'CUSTOM');
  const customOption = ALL_COUNTRIES.find((c) => c.code === 'CUSTOM');

  // Sort regular countries alphabetically
  const sorted = [...regularCountries].sort((a, b) => {
    const nameA = isAr ? a.nameAr : a.nameEn;
    const nameB = isAr ? b.nameAr : b.nameEn;
    return collator.compare(nameA, nameB);
  });

  selectEl.innerHTML = '';

  // Add Custom Option at top or bottom (Add as first option for quick custom dialing)
  if (customOption) {
    const customOpt = document.createElement('option');
    customOpt.value = customOption.code;
    customOpt.textContent = `${customOption.flag} ${isAr ? customOption.nameAr : customOption.nameEn}`;
    selectEl.appendChild(customOpt);
  }

  // Add all sorted world countries
  sorted.forEach((item) => {
    const opt = document.createElement('option');
    opt.value = item.code;
    const displayName = isAr ? item.nameAr : item.nameEn;
    opt.textContent = `${item.flag} ${displayName} (+${item.dial})`;
    selectEl.appendChild(opt);
  });

  if (defaultCode) {
    selectEl.value = defaultCode;
    if (dialInputEl) {
      const country = ALL_COUNTRIES.find((c) => c.code === defaultCode);
      if (country) {
        dialInputEl.value = country.dial;
      }
    }
  }
}

/**
 * Setup Bidirectional Sync between Country Dropdown and Dial Code Input
 */
export function setupPhoneInputSync({
  countrySelect,
  dialInput,
  phoneInput,
  onUpdate
}) {
  let isInternalSync = false;

  // 1. When user edits dial code input
  dialInput?.addEventListener('input', () => {
    if (isInternalSync) return;
    const rawVal = dialInput.value.replace(/\D/g, '');
    dialInput.value = rawVal;

    // Search for matching country
    const matched = ALL_COUNTRIES.find((c) => c.code !== 'CUSTOM' && c.dial === rawVal);
    if (matched && countrySelect) {
      if (countrySelect.value !== matched.code) {
        isInternalSync = true;
        countrySelect.value = matched.code;
        isInternalSync = false;
      }
    } else if (rawVal && countrySelect) {
      // If no exact match and user entered a custom code, select CUSTOM
      if (countrySelect.value !== 'CUSTOM') {
        isInternalSync = true;
        countrySelect.value = 'CUSTOM';
        isInternalSync = false;
      }
    }

    if (typeof onUpdate === 'function') onUpdate();
  });

  // 2. When user changes country dropdown
  countrySelect?.addEventListener('change', () => {
    if (isInternalSync) return;
    const selectedVal = countrySelect.value;

    if (selectedVal === 'CUSTOM') {
      if (dialInput) {
        dialInput.focus();
        dialInput.select();
      }
    } else {
      const country = ALL_COUNTRIES.find((c) => c.code === selectedVal);
      if (country && dialInput) {
        isInternalSync = true;
        dialInput.value = country.dial;
        isInternalSync = false;
      }
    }

    if (typeof onUpdate === 'function') onUpdate();
  });

  // 3. When user changes or types in phone input
  phoneInput?.addEventListener('input', () => {
    if (typeof onUpdate === 'function') onUpdate();
  });
  phoneInput?.addEventListener('change', () => {
    if (typeof onUpdate === 'function') onUpdate();
  });
}

/**
 * Attach Modern Phone Input Component with Searchable Country Popover & Smart Paste
 */
export function attachModernPhoneInput({
  fieldEl,
  countryBtnEl,
  flagEl,
  dialBadgeEl,
  dropdownEl,
  searchInputEl,
  listEl,
  phoneInputEl,
  dialInputEl,
  countrySelectEl,
  isAr = true,
  defaultCode = null,
  onUpdate = null
}) {
  if (!fieldEl || !countryBtnEl || !phoneInputEl) return null;

  // Initialize Country Selection
  const initialCode = defaultCode || detectUserCountry(isAr);
  let currentCountry = ALL_COUNTRIES.find((c) => c.code === initialCode) ||
    ALL_COUNTRIES.find((c) => c.code === 'SA') ||
    ALL_COUNTRIES[1];

  // Popular / Arab League codes for prioritized grouping
  const POPULAR_CODES = new Set([
    'SA', 'EG', 'AE', 'KW', 'QA', 'OM', 'BH', 'JO', 'PS', 'IQ',
    'LB', 'SY', 'YE', 'MA', 'DZ', 'TN', 'LY', 'SD', 'US', 'GB', 'DE', 'TR'
  ]);

  const collator = new Intl.Collator(isAr ? 'ar' : 'en', { sensitivity: 'base' });
  const allRegular = ALL_COUNTRIES.filter((c) => c.code !== 'CUSTOM');
  const sortedCountries = [...allRegular].sort((a, b) => {
    const nameA = isAr ? a.nameAr : a.nameEn;
    const nameB = isAr ? b.nameAr : b.nameEn;
    return collator.compare(nameA, nameB);
  });

  // Keep hidden native select in sync for form compatibility
  if (countrySelectEl) {
    populateCountrySelect(countrySelectEl, isAr, currentCountry.code, dialInputEl);
  }

  function setCountry(country, triggerUpdate = true) {
    if (!country) return;
    currentCountry = country;

    if (flagEl) flagEl.textContent = country.flag || '🌐';
    if (dialBadgeEl) dialBadgeEl.textContent = country.dial ? `+${country.dial}` : '';
    if (dialInputEl) dialInputEl.value = country.dial || '';

    if (countrySelectEl && countrySelectEl.value !== country.code) {
      countrySelectEl.value = country.code;
    }

    // Update active highlight in dropdown
    if (listEl) {
      listEl.querySelectorAll('.kz-phone-option').forEach((opt) => {
        const isMatch = opt.dataset.code === country.code;
        opt.classList.toggle('is-selected', isMatch);
        opt.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });
    }

    if (triggerUpdate && typeof onUpdate === 'function') {
      onUpdate();
    }
  }

  // Initial set without triggering redundant update
  setCountry(currentCountry, false);

  function renderList(query = '') {
    if (!listEl) return;
    listEl.innerHTML = '';
    const cleanQuery = query.trim().toLowerCase().replace(/^\+/, '');

    const filterFn = (c) => {
      if (!cleanQuery) return true;
      const name = isAr ? c.nameAr.toLowerCase() : c.nameEn.toLowerCase();
      const dial = c.dial.toLowerCase();
      const code = c.code.toLowerCase();
      return name.includes(cleanQuery) || dial.includes(cleanQuery) || code.includes(cleanQuery);
    };

    const filtered = sortedCountries.filter(filterFn);

    if (filtered.length === 0) {
      const emptyDiv = document.createElement('div');
      emptyDiv.className = 'kz-phone-empty';
      emptyDiv.textContent = isAr ? 'لا توجد دولة مطابقة للبحث' : 'No countries found';
      listEl.appendChild(emptyDiv);
      return;
    }

    // If no search query, show Popular / Arab League section at top
    if (!cleanQuery) {
      const popHeader = document.createElement('div');
      popHeader.className = 'kz-phone-list-heading';
      popHeader.textContent = isAr ? 'الدول الشائعة' : 'Popular Countries';
      listEl.appendChild(popHeader);

      const popularList = sortedCountries.filter((c) => POPULAR_CODES.has(c.code));
      popularList.forEach((c) => createOptionItem(c));

      const allHeader = document.createElement('div');
      allHeader.className = 'kz-phone-list-heading';
      allHeader.textContent = isAr ? 'جميع دول العالم' : 'All Countries';
      listEl.appendChild(allHeader);
    }

    filtered.forEach((c) => createOptionItem(c));
  }

  function createOptionItem(c) {
    const opt = document.createElement('div');
    opt.className = 'kz-phone-option';
    if (currentCountry && currentCountry.code === c.code) {
      opt.classList.add('is-selected');
    }
    opt.dataset.code = c.code;
    opt.dataset.dial = c.dial;
    opt.setAttribute('role', 'option');
    opt.setAttribute('tabindex', '0');

    const flagSpan = document.createElement('span');
    flagSpan.className = 'kz-phone-opt-flag';
    flagSpan.textContent = c.flag;

    const nameSpan = document.createElement('span');
    nameSpan.className = 'kz-phone-opt-name';
    nameSpan.textContent = isAr ? c.nameAr : c.nameEn;

    const dialSpan = document.createElement('span');
    dialSpan.className = 'kz-phone-opt-dial';
    dialSpan.textContent = `+${c.dial}`;

    opt.append(flagSpan, nameSpan, dialSpan);

    opt.addEventListener('click', () => {
      setCountry(c);
      closeDropdown();
      phoneInputEl.focus();
    });

    opt.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setCountry(c);
        closeDropdown();
        phoneInputEl.focus();
      }
    });

    listEl.appendChild(opt);
  }

  function openDropdown() {
    if (!dropdownEl) return;
    dropdownEl.hidden = false;
    countryBtnEl.setAttribute('aria-expanded', 'true');
    renderList('');
    if (searchInputEl) {
      searchInputEl.value = '';
      setTimeout(() => searchInputEl.focus(), 30);
    }
  }

  function closeDropdown() {
    if (!dropdownEl || dropdownEl.hidden) return;
    dropdownEl.hidden = true;
    countryBtnEl.setAttribute('aria-expanded', 'false');
  }

  function toggleDropdown() {
    if (!dropdownEl) return;
    if (dropdownEl.hidden) {
      openDropdown();
    } else {
      closeDropdown();
    }
  }

  countryBtnEl.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleDropdown();
  });

  searchInputEl?.addEventListener('input', () => {
    renderList(searchInputEl.value);
  });

  // Close dropdown on click outside
  document.addEventListener('click', (e) => {
    if (!fieldEl.contains(e.target)) {
      closeDropdown();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dropdownEl && !dropdownEl.hidden) {
      closeDropdown();
      countryBtnEl.focus();
    }
  });

  // Smart Paste Detection: if user pastes "+96650..." or "00201..."
  phoneInputEl.addEventListener('paste', (e) => {
    const pasted = (e.clipboardData || window.clipboardData)?.getData('text') || '';
    if (!pasted) return;

    const cleanPasted = pasted.trim().replace(/^00/, '+');
    if (cleanPasted.startsWith('+')) {
      const digitsOnly = cleanPasted.slice(1).replace(/\D/g, '');
      // Match longest dial code
      const matchingCountry = [...sortedCountries]
        .filter((c) => digitsOnly.startsWith(c.dial))
        .sort((a, b) => b.dial.length - a.dial.length)[0];

      if (matchingCountry) {
        e.preventDefault();
        const nationalPart = digitsOnly.slice(matchingCountry.dial.length).replace(/^0+/, '');
        setCountry(matchingCountry, false);
        phoneInputEl.value = nationalPart;
        if (typeof onUpdate === 'function') onUpdate();
      }
    }
  });

  phoneInputEl.addEventListener('input', () => {
    if (typeof onUpdate === 'function') onUpdate();
  });

  return {
    getCountry: () => currentCountry,
    setCountry,
    closeDropdown
  };
}
